import { render, staticRenderFns } from "./KitsV2.vue?vue&type=template&id=278f6e1f&scoped=true&"
import script from "./KitsV2.vue?vue&type=script&lang=js&"
export * from "./KitsV2.vue?vue&type=script&lang=js&"
import style0 from "./KitsV2.vue?vue&type=style&index=0&id=278f6e1f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278f6e1f",
  null
  
)

export default component.exports